<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-10">
              <v-toolbar
                :color="tab == 2 ? 'indigo darken-1' : 'teal lighten-3'"
                dark
                flat
              >
                <v-toolbar-title class="headline">
                  <v-avatar left>
                    <v-img src="@/assets/logo.png" />
                  </v-avatar>
                  スケジュール管理ログイン
                </v-toolbar-title>

                <template v-slot:extension> </template>
              </v-toolbar>

              <v-form v-model="valid" ref="form" @submit.prevent="login">
                <v-card-text class="mt-5">
                  <v-text-field
                    v-model="id"
                    class="mx-5"
                    label="ログインID"
                    prepend-inner-icon="mdi-account"
                    outlined
                    rounded
                    :rules="[Rules.Required]"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    class="mx-5"
                    label="パスワード"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="!eye ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="eye ? 'text' : 'password'"
                    outlined
                    rounded
                    :rules="[Rules.Required]"
                    @click:append="eye = !eye"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="login" color="primary" text>
                    ログイン
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Forms from "@/mixins/forms";
import ShowDialogs from "@/mixins/showDialogs";
import QrDialog from "./dialogs/QrDialog.vue";

import Login from "@/models/Login";
import Api from "@/mixins/api";

async function sleep(ms) {
  await new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  name: "Login",
  mixins: [Forms, ShowDialogs, Api],
  data() {
    return {
      id: "",
      password: "",
      isQrRead: false,
      eye: false,
      tab: 1
    };
  },
  methods: {
    async login() {
      if (!this.$refs.form.validate()) return;

      let result = false;

      this.$loading();
      try {
        const payload = new Login(
          this.id,
          this.password,
          this.tab,
          this.isQrRead
        );

        await sleep(2000);
        const resp = await this.$auth(payload);

        result = await this.$store.commit("login", resp);
        console.log(result);

        let authority = this.$store.state.authority;
        if (authority == undefined || authority == null || authority === "") {
          authority = "0";
        }

        //if (this.$vuetify.breakpoint.mobile) this.$router.push("/workreport");
        //else if (authority == "5" || authority == "9") {
        //  this.$router.push("/workcompletionapproval");
        //} else this.$router.push("/office");
        // 暫定対応：管理者は、承認画面、それ以外は実績入力画面に遷移するように対応
        if (authority == "5" || authority == "9") {
          this.$router.push("/workcompletionapproval");
        } else {
          this.$router.push("/workreport");
        }
      } catch (e) {
        this.$error(e.message);
      } finally {
        this.$unloading();
      }
    },
    async readQr() {
      const result = await this.$showDialog(QrDialog);
      console.log(result);

      const split = result.split("@");
      this.id = split[0];
      this.password = split[1];
      this.isQrRead = true;

      await new Promise(resolve => setTimeout(resolve, 500));

      await this.login();
    }
  }
};
</script>

<style></style>
